export function deepMerge(target: Record<string, unknown>, source: Record<string, unknown>) {
  for (const [key] of Object.entries(source)) {
    if (isPrimitiveType(source[key] as unknown)) {
    }
    target[key] = source[key]
  }
}

export function isPrimitiveType(v: unknown) {
  const types = ['number', 'string', 'boolean', 'undefined']

  return types.includes(typeof v)
}

export function advanceAssignObject(
  options: {
    ignoreUndefined?: boolean
  },
  target: { [key: string]: unknown },
  ...rest: { [key: string]: unknown }[]
) {
  if (options.ignoreUndefined === true) {
    for (const source of rest) {
      for (const key in source) {
        if (source[key] !== undefined && Object.hasOwnProperty.call(source, key)) {
          target[key] = source[key]
        }
      }
    }
    return target
  }
  return Object.assign(target, ...rest)
}

export function getRandomStr(length: number) {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'

  return Array.from({ length }, () => chars[Math.floor(Math.random() * chars.length)]).join('')
}

export function thruttle(fn: (...args: unknown[]) => void, delay: number = 500) {
  let lastTime = 0
  let timer: any = undefined

  return function (...args: unknown[]) {
    const now = Date.now()

    clearTimeout(timer)
    if (now - lastTime > delay) {
      fn(...args)
      lastTime = now
    } else {
      timer = setTimeout(() => {
        fn(...args)
      }, delay)
    }
  }
}
